import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { RMDClientFavouriteCarriersModel } from 'src/Models/RMDClientFavouriteCarriersModel';
import { FrontRmdupdatesService } from 'src/Services/Frontrmdupdates.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-rmdmy-favorites',
  templateUrl: './rmdmy-favorites.component.html',
  styleUrls: ['./rmdmy-favorites.component.css']
})
export class RMDMyFavoritesComponent implements OnInit {
  dropdownListProviders = [];
  dropdownSettingsProviders = {};
  selectedItemsProviders = [];
  favoriteProviderList = [];
  providerList = [];
  isloading: boolean = false;
  tokenKey: string = '';
  userID: number;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  carrierId: number;
  rmdUnreadflag:boolean=true;
  rmdUnread: number = 0;

  constructor(private readonly rmdupdatesService: FrontRmdupdatesService, 
    private readonly toastr: ToastrService,
    private readonly titleService: Title, 
    private readonly checkAuth: CheckAuth,
    private sessionStorageService: SessionStorageService) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');
    this.titleService.setTitle('My Favorites | JSi360');
    //this.tokenKey = this.sessionStorageService.getTokenValue();

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.rmdUnreadflag = true;
    let rmdReadflag= sessionStorage.getItem('rmdUnreadflag');
    this.rmdUnreadflag = rmdReadflag === 'true' ? true : false;

    let rmdUnreadcount= sessionStorage.getItem('rmdUnread');

    this.rmdUnread=parseInt(rmdUnreadcount);

    this.movetotop();
    this.isloading = false;
    this.GetRMDClientFavouriteCarriers();
    this.dropdownSettingsProviders = {
      singleSelection: false,
      text: "Select Provider(s)",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Provider available',
      showCheckbox: true,
      enableFilterSelectAll: false,
      enableCheckAll: false,
      primaryKey: 'carrierId',
      labelKey: 'business_name',
    };
  }

  ngOnInit() {
    
  }

  GetRMDClientFavouriteCarriers() {
    this.favoriteProviderList = [];
    this.dropdownListProviders = [];
    this.selectedItemsProviders = [];
    this.blockDocument();
    this.rmdupdatesService.GetRMDClientFavouriteCarriers(this.tokenKey, this.userID).subscribe(
      data => {
        this.unblockDocument();
        if (data["updates"] != null) {
          this.providerList = data["updates"];
          this.favoriteProviderList = this.providerList.filter(x => x.favouriteId != 0);
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
        }
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  RemoveStarFavorite(id: number, Type: string) {
    this.carrierId = id;
    var elem = document.getElementById("lnkFavouriteValidation");
    elem.click();
  }

  OnSelectProvider($event) {
    this.SaveFavoriteProvider($event['carrierId'], true);
  }

  OnDeSelectProvider($event) {
    this.SaveFavoriteProvider($event['carrierId'], false);
  }

  SaveFavoriteProvider(id: number, IsFavorite: boolean) {
    const favouriteCarriersModel = new RMDClientFavouriteCarriersModel();
    favouriteCarriersModel.clientId = this.userID;
    favouriteCarriersModel.isFavourite = IsFavorite;
    favouriteCarriersModel.carrierId = id;
    this.rmdupdatesService.RMDClientCarrierFavouriteAddRemove(this.tokenKey, favouriteCarriersModel)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (IsFavorite) {
            this.showMessage('Selected provider added successfully to favorite list.', 'Favorite', 'success');
          }
          else {
            this.favoriteProviderList = this.favoriteProviderList.filter(x => x.carrierId != id)
            this.showMessage('Selected provider removed successfully from favorite list.', 'Favorite', 'success');
          }
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }

      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  DeselectFavourite() {
    document.getElementById("btnClose").click();
    this.SaveFavoriteProvider(this.carrierId, false);
  }

  CancelDeselectFavourite() {
    document.getElementById("btnClose").click();
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

}
